<template lang="html">
  <div></div>
</template>

<script>
import { bus } from "@/main";

export default {
  mounted() {
    bus.$on("makeToast", (titleInput, bodyInput, variantInput) => {
      this.makeToast(titleInput, bodyInput, variantInput);
    });
  },

  data() {
    return {
      variant: "unstitched",
      title: "",
      body: "",
      count: 0
    };
  },

  methods: {
    makeToast(titleInput, bodyInput, variantInput) {
      if (variantInput) this.variant = variantInput;
      if (titleInput) this.title = titleInput;
      if (bodyInput) this.body = bodyInput;

      this.buildToast();
    },

    buildToast() {
      const h = this.$createElement;
      this.count++;

      const vNodesMsg = h("p", { class: ["mb-0"] }, this.body);
      const vNodesTitle = h(
        "div",
        { class: ["d-flex", "flex-grow-1", "align-items-baseline", "mr-2"] },
        [h("strong", { class: "mr-2" }, this.title)]
      );

      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: this.variant,
        autoHideDelay: 5000,
        appendToast: true
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/toast/Toast.vue